import Vue from 'vue'
import Vuex from 'vuex'
import sideBar from './SideBar'
import userInfo from './UserInfo'
import roles from './Roles'
import staffs from './Staffs'
import building from './Building'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    sideBar,
    userInfo,
    roles,
    staffs,
    building
  }
})

export default store
